import { EndpointGroup } from '@gis/endpoint-registry';

const userTaskEP = EndpointGroup.build("user-task");

export default class UserTasksEndpoints {
    static list = userTaskEP.get("list");
    static get = userTaskEP.get("");
}